import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { faBug } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type IReportsModalProps = {
	mostrarModal: boolean,
	fecharModal: (mostrarModal: boolean) => void,
};

export default function ReportsModal(props: IReportsModalProps) {
	const [campos, setCampos] = useState({
		sumario: "",
		descricao: "",
		url_erro: "",
		imagens: [],
	});

	function fecharModal() {
		props.fecharModal();
		setCampos({
			sumario: "",
			descricao: "",
			url_erro: "",
			imagens: [],
		});
	}

	async function enviarReporte() {}

	return (
		<Modal
			show={props.mostrarModal}
			cancel={props.close}
			onHide={props.fecharModal}
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title><FontAwesomeIcon icon={faBug}/>&nbsp; Reportar erro ou enviar sugestão</Modal.Title>
			</Modal.Header>

			<Modal.Body>
                Por enquanto, nos envie um email para <a href="mailto:museufmrp@gmail.com" >museufmrp@gmail.com</a> com os detalhes!
                {/**
				<Form>
					<Form.Group controlId="sumario" className="mb-2">
						<Form.Label>Sumário</Form.Label>
						<Form.Control
							type="text"
							placeholder="Sumário"
							value={campos.sumario}
							onChange={(e) =>
								setCampos({ ...campos, sumario: e.target.value })
							}
						/>
					</Form.Group>

					<Form.Group controlId="descricao" className="mb-2">
						<Form.Label>Descrição</Form.Label>
						<Form.Control
							as="textarea"
							rows={3}
							placeholder="Descrição"
							value={campos.descricao}
							onChange={(e) =>
								setCampos({ ...campos, descricao: e.target.value })
							}
						/>
					</Form.Group>

					<Form.Group controlId="url_erro" className="mb-2">
						<Form.Label>URL do erro</Form.Label>
						<Form.Control
							type="text"
							placeholder="URL em que o erro ocorreu"
							value={campos.url_erro}
							onChange={(e) =>
								setCampos({ ...campos, url_erro: e.target.value })
							}
						/>
					</Form.Group>

					<Form.Group controlId="imagens" className="mb-2">
						<Form.Label>Imagens</Form.Label>
						<Form.Control
							type="file"
							multiple
							onChange={(e) =>
								setCampos({ ...campos, imagens: e.target.value })
							}
						/>
					</Form.Group>
				</Form>
                 */}
			</Modal.Body>

			<Modal.Footer>
				<Button variant="secondary" onClick={fecharModal}>
					Cancelar
				</Button>
{/*				<Button variant="success" onClick={enviarReporte}>
					Enviar
				</Button>
            */}
			</Modal.Footer>
		</Modal>
	);
}
